<template>
    <v-layout>
        <v-flex xs12>
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <v-tabs
                                        background-color="transparent"
                                        color="basil"
                                        grow
                                        v-model="footer_language"
                                    >
                                        <v-tab v-for="language in enabledLanguages" :key="language.value">
                                            {{ language.text }}
                                        </v-tab>
                                    </v-tabs>
                                </v-flex>
                                <v-flex xs6>
                                    <div style="float: right;" v-if="footer_language === 0">
                                        <v-tooltip 
                                            bottom
                                            max-width="300"
                                            color="grey darken-3"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    color="grey lighten-3"
                                                    class="override-btn"
                                                    outlined
                                                    style="float:right"
                                                    small
                                                    @click="setFieldLanguageData(['description'], footer_properties.data)"
                                                >
                                                {{ $t('language_copy_all_button_label') }}
                                                </v-btn>
                                            </template>
                                            <div class="pa-2">
                                                <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-title>
                        <v-card-text class="mt-3">
                            <v-tabs-items v-model="footer_language">
                                <v-tab-item
                                    v-for="language in enabledLanguages"
                                    :key="language.text"
                                >
                                <v-card
                                    color="basil"
                                    flat
                                >
                                    <v-card-text>
                                        <v-flex xs12 class="px-2">
                                            <v-textarea outline
                                                :label="$t('company_footer_setting_description_label',{lang:language.text})"
                                                :name="`about_company${language.value}`"
                                                v-model="footer_properties.data.description[language.value]"
                                                class="mx-2"
                                            />
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- Quick Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="footer_properties.configurations.quick_links" style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_quick_link_label') }}
                                <template >
                                    <v-btn class="ml-2" small color="primary" @click="addFooterLinks('quick')"> + Add Link </v-btn>
                                </template>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="footer_properties.configurations.quick_links">
                            <v-layout v-for="quick_link, quick_index in footer_properties.data.QuickLinks" :key="quick_index" class="mt-4">
                                <v-flex xs12>
                                    <v-card elevation="2">
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <!-- Link Name -->
                                                <v-flex xs12>
                                                    <v-layout row wrap>
                                                        <v-flex xs4 sm4 v-for="(language, quick_lang_index) in enabledLanguages" :key="quick_lang_index">
                                                            <v-text-field
                                                                v-model="quick_link.title[language.value]"
                                                                :id="'text-' + language.value+ ' ' + quick_lang_index"
                                                                :label="'Title in ' + language.text"
                                                                name="text"
                                                                counter="255"
                                                                color="primary"
                                                                prepend-icon="$vuetify.icons.rms_agreement"
                                                                type="text"
                                                                class="pr-3"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mt-3 mb-3"></v-divider>
                                            <v-layout row wrap>
                                                <!-- URL Input -->
                                                <v-flex xs12 sm12 md6 lg8>
                                                    <v-text-field
                                                        :id="`link-${quick_index}`"
                                                        :label="'Link'"
                                                        name="link"
                                                        color="primary"
                                                        prepend-icon="$vuetify.icons.rms_agreement"
                                                        type="text"
                                                        class="pr-3"
                                                        v-model="quick_link.link"
                                                    />
                                                </v-flex>
                                                <!-- Tab Selection -->
                                                <v-flex xs12 sm12 md2 lg2>
                                                    <v-select
                                                    :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                    label="Opens In"
                                                    class="pr-3"
                                                    :id="`Quick-Traget-${quick_index}`"
                                                    v-model="quick_link.target"
                                                    />
                                                </v-flex>
                                                <!-- Delete Link -->
                                                <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                    <v-btn color="error" small icon fab @click="removeFooterLinks({type:'quick',removeIndex:quick_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Quick Links -->
            <!-- Legal Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="footer_properties.configurations.legal_links"  style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_legal_link_label') }}
                                <template >
                                    <v-btn class="ml-2" small color="primary" @click="addFooterLinks('legal')"> + Add Link </v-btn>
                                </template>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="footer_properties.configurations.legal_links">
                            <v-layout v-for="(legal_link, legal_index) in footer_properties.data.LegalLinks" :key="legal_index" class="mt-4">
                                <v-flex xs12>
                                    <v-card elevation="2">
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <!-- Link Name -->
                                                <v-flex xs12>
                                                    <v-layout row wrap>
                                                        <v-flex xs4 v-for="(language, legal_lang_index) in enabledLanguages" :key="legal_lang_index">
                                                            <v-text-field
                                                                v-model="legal_link.title[language.value]"
                                                                :id="'text-' + language.value"
                                                                :label="'Title in ' + language.text"
                                                                name="text"
                                                                counter="255"
                                                                color="primary"
                                                                prepend-icon="$vuetify.icons.rms_agreement"
                                                                type="text"
                                                                class="pr-3"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-divider class="mt-3 mb-3"></v-divider>
                                            <v-layout row wrap>
                                                <!-- URL Input -->
                                                <v-flex xs12 sm12 md6 lg8>
                                                    <v-text-field
                                                        :id="'link-'"
                                                        :label="'Link'"
                                                        name="link"
                                                        color="primary"
                                                        prepend-icon="$vuetify.icons.rms_agreement"
                                                        type="text"
                                                        v-model="legal_link.link"
                                                        class="pr-3"
                                                    />
                                                </v-flex>
                                                <!-- Tab Selection -->
                                                <v-flex xs12 sm12 md2 lg2>
                                                    <v-select
                                                    :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                    label="Opens In"
                                                    class="pr-3"
                                                    v-model="legal_link.target"
                                                    />
                                                </v-flex>
                                                <!-- Delete Link -->
                                                <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                    <v-btn color="error" small icon fab @click="removeFooterLinks({type:'legal',removeIndex:legal_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
    
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Legal Links -->
            <!-- Sical Media Links -->
            <v-layout>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <div class="d-inline-flex">
                                <v-checkbox hide-details color="primary" v-model="footer_properties.configurations.social_media_links"  style="margin-top: -7px;"></v-checkbox>
                            </div>
                            <h2>
                                {{ $t('company_footer_setting_dynamic_footer_social_media_link_label') }}
                                <v-btn class="ml-2" small color="primary"  @click="addFooterLinks('social')"> + Add Link </v-btn>
                            </h2>
                        </v-card-title>
                        <v-card-text v-if="footer_properties.configurations.social_media_links">
                            <v-layout row wrap v-for="(social_links, socail_index) in footer_properties.data.SocalMediaLinks" :key="socail_index">
                                <v-flex xs12>
                                    <v-card elevation="2">
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <!-- Link Name -->
                                                <v-flex xs12 sm12 md3 lg5>
                                                    <v-select
                                                        :items="DEFINES.SOCIAL_MEDIA_LINK_TYPES"
                                                        label="Type"
                                                        class="pr-3"
                                                        v-model="social_links.type"
                                                    />
                                                </v-flex>
                                                <!-- URL Input -->
                                                <v-flex xs12 sm12 md6 lg4>
                                                    <v-text-field
                                                        :id="'link-'"
                                                        :label="'Link'"
                                                        name="link"
                                                        color="primary"
                                                        prepend-icon="$vuetify.icons.rms_agreement"
                                                        type="text"
                                                        class="pr-3"
                                                        v-model="social_links.link"
                                                    />
                                                </v-flex>
                                                <!-- Tab Selection -->
                                                <v-flex xs12 sm12 md2 lg2>
                                                    <v-select
                                                    :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                                    label="Opens In"
                                                    class="pr-3"
                                                    v-model="social_links.target"
                                                    />
                                                </v-flex>
                                                <!-- Delete Link -->
                                                <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                                    <v-btn color="error" small icon fab @click="removeFooterLinks({type:'social',removeIndex:socail_index})"><v-icon>mdi-delete</v-icon></v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
    
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Sical Media Links -->
        </v-flex>
    </v-layout>
</template>

<script>
import DEFINES from '@/defines';
import { mapState } from "vuex";

export default {
    name : 'ThemeFooterConfigurations',
    props:{
        properties:{
            type:Object,
            default:null
        }
    },
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
        enabledLanguages() {
            if (this.company) {
                return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : DEFINES.LOCALES; 
            }else{
                return DEFINES.LOCALES
            }
        },
    },
    data() {
        return {
            footer_properties:{
                enable_feature:true,
                configurations : {
                    quick_links : false,
                    legal_links:false,
                    social_media_links:false
                },
                data :{
                    description:{
                        en : '',
                        es : '',
                        he : '',
                        ru : '',
                        fr : '',
                        it : '',
                        cs : '',
                        de : '' 
                    },
                    QuickLinks:[
                        JSON.parse(JSON.stringify(DEFINES.WIDGET_QUICK_LINK_DEFAULT))
                    ],
                    LegalLinks:[
                        JSON.parse(JSON.stringify(DEFINES.WIDGET_LEGAL_LINK_DEFAULT))
                    ],
                    SocalMediaLinks:[
                        JSON.parse(JSON.stringify(DEFINES.WIDGET_SOCAIL_MEDIA__DEFAULT))
                    ],
                }
            },
            footer_language:null,
        }
    },
    created(){
        if (('footer_configurations' in this.properties) && this.properties.footer_configurations.enable_feature) {
            this.footer_properties = this.properties.footer_configurations
        }
    },
    methods:{
        addFooterLinks(type) {
            switch (type) {
                case 'quick':
                    this.footer_properties.data.QuickLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_QUICK_LINK_DEFAULT)))
                    break;
                case 'legal':
                    this.footer_properties.data.LegalLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_LEGAL_LINK_DEFAULT)))
                    break;
                case 'social':
                    this.footer_properties.data.SocalMediaLinks.push(JSON.parse(JSON.stringify(DEFINES.WIDGET_SOCAIL_MEDIA__DEFAULT)))
                    break;
                default:
                    break;
            }
        },
        removeFooterLinks({type, removeIndex}){
            switch (type) {
                case 'quick':
                    this.footer_properties.data.QuickLinks.splice(removeIndex, 1);
                    break;
                case 'legal':
                    this.footer_properties.data.LegalLinks.splice(removeIndex, 1);
                    break;
                case 'social':
                    this.footer_properties.data.SocalMediaLinks.splice(removeIndex, 1);
                    break;
                default:
                    break;
            }
            
        },
        setFieldLanguageData(fields, stateObject) {
            let __this = this
            fields.forEach(field => {
                __this.enabledLanguages.forEach((lang) => {
                if (lang.value !== 'en') {
                    stateObject[field][lang.value] = stateObject[field]['en']
                }
                });
            });
        },
    }        
}
</script>

<style lang="scss" scoped>

</style>
